import {
    DOMAIN_LIST_EXPANDED_LIMIT,
    DOMAIN_LIST_PREVIEW_LIMIT,
    DOMAIN_LIST_SHOW_MORE_MIN_REMAINING,
    DOMAIN_PAGE_SIZE,
} from "../const";
import type { IGrowthOverviewTableRow } from "../types";

export interface IVisibleDomainChildrenResult {
    visibleChildren: IGrowthOverviewTableRow[];
    showShowAllRow: boolean;
    remainingCount: number;
    shouldFetchMore?: boolean;
}

export const getVisibleDomainChildren = (
    children: IGrowthOverviewTableRow[],
    isShowAll: boolean,
    totalDomainCount?: number,
    previewLimit = DOMAIN_LIST_PREVIEW_LIMIT,
    expandedLimit = DOMAIN_LIST_EXPANDED_LIMIT,
): IVisibleDomainChildrenResult => {
    const totalCount = totalDomainCount ?? children.length;
    const hasMoreOnServer = totalCount > children.length;

    if (isShowAll) {
        const visibleChildren = children.slice(0, expandedLimit);
        const remainingOnServer = totalCount - children.length;

        if (hasMoreOnServer && visibleChildren.length >= Math.min(children.length, expandedLimit)) {
            return {
                visibleChildren,
                showShowAllRow: true,
                remainingCount: Math.min(remainingOnServer, DOMAIN_PAGE_SIZE),
                shouldFetchMore: true,
            };
        }

        return {
            visibleChildren,
            showShowAllRow: false,
            remainingCount: 0,
        };
    }

    if (children.length <= previewLimit) {
        return {
            visibleChildren: children,
            showShowAllRow: false,
            remainingCount: 0,
        };
    }

    const remainingCount = Math.min(children.length - previewLimit, expandedLimit - previewLimit);
    if (remainingCount < DOMAIN_LIST_SHOW_MORE_MIN_REMAINING) {
        return {
            visibleChildren: children,
            showShowAllRow: false,
            remainingCount: 0,
        };
    }

    return {
        visibleChildren: children.slice(0, previewLimit),
        showShowAllRow: true,
        remainingCount,
    };
};
